import {
  GiMiniSubmarine,
  GiEchoRipples,
  GiRadarSweep,
  GiRobotGrab,
} from "react-icons/gi";
import { FaDroplet } from "react-icons/fa6";
import { IoCamera } from "react-icons/io5";
import { TbScanPosition } from "react-icons/tb";
import { FaShip, FaWater } from "react-icons/fa";

const renderNodeIconAndName = (node: any, getType: (node: any) => string) => (
  <>
    <div className="w-6 flex-shrink-0">{getIconForType(getType(node))}</div>
    <span className="max-w-[14rem] flex-grow break-words pr-2 text-sm">
      {node.name}
    </span>
  </>
);

const getIconForType = (realAssetType: string) => {
  const iconClass = "mr-2 w-[18px] h-[18px]";
  switch (realAssetType) {
    case "vessel":
      return <FaShip className={iconClass} />;
    case "rov":
      return <GiRobotGrab className={iconClass} />;
    case "submersible":
      return <GiMiniSubmarine className={`${iconClass} -mt-1`} />;
    case "multibeam_echosounder":
    case "split_beam_echosounder":
      return <GiEchoRipples className={iconClass} />;
    case "sub_bottom_profiler":
      return <GiRadarSweep className={iconClass} />;
    case "acoustic_doppler_current_profiler":
      return <FaWater className={iconClass} />;
    case "positioning_system":
      return <TbScanPosition className={iconClass} />;
    case "sound_speed_equipment":
      return <FaDroplet className={iconClass} />;
    case "camera":
      return <IoCamera className={iconClass} />;
    default:
      return null;
  }
};

export { renderNodeIconAndName, getIconForType };
